
































































import Vue from "vue";

import DropdownButton from "@tt-app/components/ui/button/DropdownButton.vue";
import ProblemCountSelectionModal from "@tt-app/components/skills/ProblemCountSelectionModal.vue";
import SkillCompletionGraph from "@tt-app/components/skills/SkillCompletionGraph.vue";
import SkillsLineGraph from "@tt-app/components/skills/SkillsLineGraph.vue";
import SkillLevelSelectModal from "@tt-app/components/skills/SkillLevelSelectModal.vue";
import { ROUTES, SKILL_PRACTICE_TYPES } from "@tt-app/constants";

interface Data {
  cancelToLevelSelection: boolean;
  modals: {
    [modalName: string]: {
      open: boolean;
    };
  };
  selectedProblemCount?: number;
}

interface Methods {
  levelSelectionCanceledHandler: () => void;
  levelSelectionConfirmedHandler: (selectedIndex: number) => void;
  levelSelectionOpenHandler: () => void;
  openPracticeView: () => void;
  problemCountSelectionClosedHandler: () => void;
  problemCountSelectionCanceledHandler: () => void;
  problemCountSelectionConfirmedHandler: (problemCount: number) => void;
  problemCountSelectionOpenHandler: () => void;
}

interface Computed {
  levelCompletion?: number;
  selectedLevel?: {
    learned: number;
    possible: number;
    title: string;
  };
  title: string;
}

interface Props {
  chartData: any;
  learnedWords: number;
  levels: {
    learned: number;
    possible: number;
    title: string;
  }[];
  selectedLevelIndex: number;
  type: number;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SkillCard",
  components: {
    DropdownButton,
    ProblemCountSelectionModal,
    SkillCompletionGraph,
    SkillLevelSelectModal,
    SkillsLineGraph
  },
  props: {
    chartData: {
      type: Object,
      default: () => ({})
    },
    learnedWords: {
      type: Number,
      default: undefined
    },
    levels: {
      type: Array,
      default: undefined
    },
    selectedLevelIndex: {
      type: Number,
      default: 0
    },
    type: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      cancelToLevelSelection: false,
      modals: {
        levelSelection: {
          open: false
        },
        problemCountSelection: {
          open: false
        }
      },
      selectedProblemCount: undefined
    };
  },
  computed: {
    levelCompletion() {
      if (!this.selectedLevel) return undefined;

      const { learned, possible } = this.selectedLevel;

      if (!learned || !possible) return 0;

      return Math.round((learned / possible) * 100);
    },
    selectedLevel() {
      if (!this.levels) return undefined;

      return this.levels[this.selectedLevelIndex];
    },
    title() {
      return `skills.practice.${SKILL_PRACTICE_TYPES[this.type]}`;
    }
  },
  methods: {
    levelSelectionCanceledHandler() {
      this.modals.levelSelection.open = false;
    },
    levelSelectionConfirmedHandler(selectedIndex) {
      this.$emit("level-selection-change", selectedIndex);
      this.cancelToLevelSelection = true;
      this.modals.levelSelection.open = false;
      this.modals.problemCountSelection.open = true;
    },
    levelSelectionOpenHandler() {
      this.modals.levelSelection.open = true;
    },
    openPracticeView() {
      const routes: { [key: number]: string } = {
        [SKILL_PRACTICE_TYPES.listening]: ROUTES.SKILLS.LISTENING_PRACTICE.NAME,
        [SKILL_PRACTICE_TYPES.pronunciation]: ROUTES.SKILLS.PRONUNCIATION_PRACTICE.NAME,
        [SKILL_PRACTICE_TYPES.vocabulary]: ROUTES.SKILLS.VOCABULARY_PRACTICE.NAME
      };

      let query: any = {
        problemCount: `${this.selectedProblemCount}`
      };

      const schoolGrade = this.selectedLevel?.title;

      if (schoolGrade) {
        query = {
          ...query,
          schoolGrade: `${schoolGrade}`
        };
      }

      this.$router.push({
        name: routes[this.type],
        query
      });
    },
    problemCountSelectionClosedHandler() {
      this.cancelToLevelSelection = true;
      this.modals.problemCountSelection.open = false;
    },
    problemCountSelectionCanceledHandler() {
      if (this.cancelToLevelSelection) {
        this.cancelToLevelSelection = false;
        this.modals.levelSelection.open = true;
      }

      this.modals.problemCountSelection.open = false;
    },
    problemCountSelectionConfirmedHandler(problemCount) {
      if (this.cancelToLevelSelection) {
        this.cancelToLevelSelection = false;
      }

      this.selectedProblemCount = problemCount;

      this.modals.problemCountSelection.open = false;

      this.openPracticeView();
    },
    problemCountSelectionOpenHandler() {
      this.modals.problemCountSelection.open = true;
    }
  }
});
